import React, { useEffect } from "react";
import AppRoutes from "./AppRoutes";
import BookInfo from "@popups/BookInfo";
import SoundAndReadContainer from "@popups/SoundAndReadContainer";
import WordPopupContainer from "@popups/WordPopupContainer";
import ActivityContainer from "@pages/ActivityContainer";
import GameContainer from "@pages/GameContainer";
import BookSoundPlayerContainer from "@popups/BookSoundPlayerContainer";
import ModalContainer from "@popups/ModalContainer";
import ZoomViewContainer from "@popups/ZoomViewContainer";
import PopupContainer from "@popups/PopupContainer";
import useModal from "@hooks/useModal";

const Home = () => {
  const { showAlert } = useModal();
  useEffect(() => {
    //Native.getWelcomeMsg()
    window.backButtonAction = function () {
      showAlert(`종료하시겠습니까?`, "confirm").then((value) => {
        if (value === true) {
          if (window.Native) window.Native.backButtonAction();
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <AppRoutes />
      <BookInfo />
      <WordPopupContainer />
      <SoundAndReadContainer />
      <BookSoundPlayerContainer />
      <ActivityContainer />
      <GameContainer />
      <ZoomViewContainer />
      <ModalContainer />
      <PopupContainer />
      <div id="loading" />
    </>
  );
};

export default Home;
